import { useState, useEffect } from 'react';
import { EmpresaService } from '../services/EmpresaService';
import { getBaseUrl } from '../config/api';

function setFavicon(url) {
    let linkIcon = document.querySelector("link[rel*='icon']");
    if (!linkIcon) {
        linkIcon = document.createElement('link');
        linkIcon.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(linkIcon);
    }
    linkIcon.href = url;
}

function buildLogoUrl(baseUrl, filename) {
    return filename ? `${baseUrl}/uploads/logos/${filename}` : null;
}

export function useEmpresaLogos() {
    const [logos, setLogos] = useState({
        logo_login: null,
        logo_dashboard: null,
        icon: null,
        nombre: ""
    });
    const [loadingLogos, setLoadingLogos] = useState(true);
    const baseUrl = getBaseUrl();

    useEffect(() => {
        let isMounted = true;

        const cargarLogos = async () => {
            try {
                const data = await EmpresaService.getLogos();
                if (!data || !isMounted) return;

                setLogos({
                    logo_login: buildLogoUrl(baseUrl, data.logo_login),
                    logo_dashboard: buildLogoUrl(baseUrl, data.logo_dashboard),
                    login_background: buildLogoUrl(baseUrl, data.login_background),
                    icon: buildLogoUrl(baseUrl, data.icon)
                });

                if (data.name_app) {
                    document.title = data.name_app;
                }

                const iconUrl = buildLogoUrl(baseUrl, data.icon);
                if (iconUrl) setFavicon(iconUrl);
            } catch (err) {
                console.error("Error cargando logos desde el Hook:", err);
            } finally {
                if (isMounted) setLoadingLogos(false);
            }
        };

        cargarLogos();

        return () => {
            isMounted = false;
        };
    }, [baseUrl]);

    return { logos, loadingLogos };
}